import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { EMPTY, empty, Observable, of } from 'rxjs'
import { SecurityQuestionService } from '../../../api/services/security-question.service'
import { catchError } from 'rxjs/operators'
import { SecurityQuestions } from '../../../api/models/security-questions'

@Injectable({
  providedIn: 'root',
})
export class QuestionResolverService {
  constructor(private securityQuestionService: SecurityQuestionService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.securityQuestionService
      .securityQuestionGet({ pageNumber: 1, pageSize: 100000 })
      .pipe(
        catchError((err) => {
          //     create error handler here
          console.log(err)
          return of(null)
        }),
      )
  }
}
